import { render, staticRenderFns } from "./CommentsBlogsCreate.vue?vue&type=template&id=6144968a&scoped=true&"
import script from "./CommentsBlogsCreate.vue?vue&type=script&lang=js&"
export * from "./CommentsBlogsCreate.vue?vue&type=script&lang=js&"
import style0 from "./CommentsBlogsCreate.vue?vue&type=style&index=0&id=6144968a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6144968a",
  null
  
)

export default component.exports